export const loveQuotes = [
  {
    text: "Let’s never give up on each other on the same day.",
    date: "29th Nov, 2025",
  },
  {
    text: "I’ve been dreaming of a good life for us, and eventually, when you read this, I’m sure that we can lead a happy, peaceful life together!",
    date: "Sept 2023",
  },
  {
    text: "Unaku doubt vara chance iruku, ivan sila vishaythula ivlo mature ah irkane, ivanuku kandippa oru ex aachum irukkum nu 🤣. I guess, hopefully when we speak one day, I would have told you about the youtube channels I used to watch and understand things and improve myself and ex laam illa enaku 🤣",
    date: "Oct 2023",
  },
  {
    text: "You know what, you’ve been my motivator since my college days, when I realised I should work harder to make us happy, and we will be!",
    date: "Jan 2024",
  },
  {
    text: "Finally, got placed! 9.5LPA 😁 ... 1st guy to get placed in our college, and you already know that....",
    date: "July 15th 2024",
  },
  {
    text: `Got my first salary dear!
12,500 Rs`,
    date: "30.04.2025",
    color: "#85BB65",
  },
  {
    text: `After all of my hard work, perseverance and all 4 years of tough times at college, striving to learn something better than others, improving my skills, getting placed in the first campus placement for 9.5 LPA package and what not!`,
    date: "30.04.2025",
    color: "#85BB65",
  },
  {
    text: `I had just started my internship and here it is… my first salary.
I promise to build a happy family here!`,
    date: "30.04.2025",
    color: "#85BB65",
  },
  {
    text: `And, inniku I got a new thought!
How about us, celebrating anniversary with a pic taken on last anniversary framed, on every anniversary?`,
    date: "30.04.2025",
    color: "#85BB65",
  },
  {
    text: `Namakku anniversary irka mari, I would love to have an anniversary for our family, on the birthday of our child.
Nalla irku la?`,
    date: "30.04.2025",
    color: "#85BB65",
  },
  {
    text: `Kaasu kai la kedacha santhoshathula, unakum enakum aana future strong ah build panna mudiyum nu oru confidence la, ivlo thoughts inniku!`,
    date: "30.04.2025",
    color: "#85BB65",
  },
  {
    text: `Nee yaaru nu kooda enaku innum therila,
But see how you’ve made me build dreams with you and achieve them… But I wish you are yogaa.... (If you are not yogaa, I'll tell how good yoga was as a person, when I speak with you.. already sollirpen 😅)

Love you, my so-far unknown one! ❤️`,
    date: "30.04.2025",
    color: "#85BB65",
  },
  {
    text: `Let's get committed to understanding each other through times and growing together.... `,
    date: "08.03.2026",
    color: "#de075d",
  },
  {
    text: `I had always dreamt of us, watching the stars in Hanle / Ladakh, with a rooftop tent on a Thar car (Thar roxx).... But, I have to buy a car now, this is my last and only chance to fix mom and dad.... And I'm just 5 months into my first job.. I am not able to afford us a Thar roxx, ippothaiku Baleno vanguren, Thar roxx --> namma future la vangidlam ma... This is gonna be even sweeter! `,
    date: "08.03.2026",
    color: "#b8b218",
  },
  {
    text: `Finally, you are Yogaaa❤️ My Yogaa, my soulmate✨`,
    date: "22.04.2026",
    color: "#de075d",
  },
];
